import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

export default function InvestmentAngle() {
    const { t } = useT();
    const bullets = [
        t("inv.bullet_1"),
        t("inv.bullet_2"),
        t("inv.bullet_3"),
        t("inv.bullet_4"),
    ];

    return (
        <section
            id="invest"
            className="relative py-24 md:py-36 bg-charcoal-surface overflow-hidden"
            data-testid="investment-section"
        >
            {/* Huge background type */}
            <div
                aria-hidden
                className="absolute -top-10 left-0 right-0 text-[22vw] font-display font-black tracking-tighter text-white/[0.025] pointer-events-none select-none leading-none"
            >
                ASSET
            </div>

            <div className="relative mx-auto max-w-7xl px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                    className="lg:col-span-7"
                >
                    <div className="flex items-center gap-3 mb-6">
                        <span className="inline-block w-8 h-[1px] bg-gold" />
                        <span className="text-[11px] tracking-[0.4em] uppercase text-gold font-semibold">
                            {t("inv.overline")}
                        </span>
                    </div>
                    <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.02]">
                        {t("inv.heading")}
                    </h2>
                    <p className="mt-8 text-lg md:text-xl text-white/70 max-w-2xl leading-relaxed">
                        {t("inv.body_before")}
                        <span className="text-white">{t("inv.body_highlight")}</span>
                        {t("inv.body_after")}
                    </p>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.15 }}
                    className="lg:col-span-5 flex items-end"
                >
                    <ul className="w-full border-t border-white/10">
                        {bullets.map((b, i) => (
                            <li
                                key={b}
                                className="flex items-center gap-4 py-5 border-b border-white/10 group"
                                data-testid={`invest-bullet-${i}`}
                            >
                                <span className="w-8 h-8 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center shrink-0 group-hover:bg-gold group-hover:text-charcoal transition-colors">
                                    <Check
                                        size={14}
                                        className="text-gold group-hover:text-charcoal"
                                        strokeWidth={2.5}
                                    />
                                </span>
                                <span className="text-base md:text-lg font-display tracking-tight">
                                    {b}
                                </span>
                            </li>
                        ))}
                    </ul>
                </motion.div>
            </div>
        </section>
    );
}
